export const ROLES = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  TL: 'TEAM_LEAD',
  ENGINEER: 'ENGINEER',
  BACKOFFICE: 'BACKOFFICE',
  CUSTOMER: 'CUSTOMER'
};

export const ROLE_LABELS = {
  [ROLES.ADMIN]: 'Administrator',
  [ROLES.MANAGER]: 'Manager',
  [ROLES.TL]: 'Team Leader',
  [ROLES.ENGINEER]: 'Field Engineer',
  [ROLES.BACKOFFICE]: 'Back Office',
  [ROLES.CUSTOMER]: 'Customer'
};

export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: ['all'],
  [ROLES.MANAGER]: ['view_all', 'reports', 'view_only'],
  [ROLES.TL]: ['manage_team', 'assign_tickets', 'view_team_tickets'],
  [ROLES.ENGINEER]: ['view_assigned', 'update_tickets', 'close_tickets'],
  [ROLES.BACKOFFICE]: ['manage_contracts', 'manage_customers', 'billing'],
  [ROLES.CUSTOMER]: ['create_tickets', 'view_own_tickets', 'view_contracts']
};